<template>
  <html>
    <head> </head>
    <body v-if="loaded">
      <navbar></navbar>

      <!--img id="header-s" src="https://i.ibb.co/1J2YTy2/Loyalty-hub-header-s.png" /-->

      <div class="title-page-l header-banner">
        <img
          class="iconpoint-top"
          src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/loyalty-hub-icon-point.png"
        />
        <p>คะเเนนสะสม</p>
        <h1>{{ info.point | numFormat("0,000,000") }}</h1>
      </div>
      <div class="row-redeem bg-white-redeem">
        <div>
          <img
            class="img-profile-redeem-page"
            :src="'https://api.loyaltyhub.me/public/' + reward.image"
            v-if="reward.image != ''"
          />
        </div>
      </div>
      <div class="detail">
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          is-full-page="true"
          style="z-index: 999"
        ></loading>
        <div class="alert alert-success" role="alert" v-if="success">
          บันทึกข้อมูลสำเร็จ
        </div>
        <div class="alert alert-danger" role="alert" v-if="failed">
          บันทึกข้อมูลไม่สำเร็จ
        </div>
        <!--img
          class="ifor"
          src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/loyalty-hub-bottom-navigation-02-redeem-point-active.png"
        /-->
        <img class="ifor" src="/assets/icon/point.svg" />
        <div class="progress" style="height: 15px">
          <div
            class="progress-bar"
            role="progressbar"
            :style="
              'width:' +
              ((reward.available || reward.quantity) * 100) / reward.quantity +
              '%'
            "
            :aria-valuenow="reward.available || reward.quantity"
            aria-valuemin="0"
            :aria-valuemax="reward.quantity"
          >
            {{ reward.available || reward.quantity | numFormat("0,000,000") }}
          </div>
        </div>

        <span class="name-product">{{ reward.name }}</span>
        <br /><span class="name-price"
          >{{ reward.point | numFormat("0,000,000") }} คะเเนน</span
        >
        <br /><span class="name-time">วันที่ {{ startDate }} - {{ endDate }}</span>

        <span style="margin-bottom: 0rem" class="p-redeem" v-html="reward.description">{{
          reward.description
        }}</span>
      </div>
      <div class="bt">
        <a
          @click="showModal('redeemConfirm')"
          type="submit"
          class="btn btn-accept light-color font-color btn-lg btn-block mt-30"
          v-if="reward.point <= info.point"
        >
          แลกคะเเนน
        </a>
      </div>
      <div class="footer">
        <span class="p-redeem">เงื่อนไข</span>
        <h3 class="p-redeem" v-html="reward.condition">
          {{ reward.condition }}
        </h3>
      </div>

      <modal name="redeemConfirm" width="80%">
        <div class="qrModal">
          <div class="card" style="width: 18rem">
            <div class="card-body">
              <h5 class="card-title">ยืนยันการแลกคะแนน</h5>
              <br />
              <p style="text-align: center !important" class="card-text">
                แลกคะแนน {{ reward.point | numFormat("0,000,000") }} เพื่อรับ
                {{ reward.name }} การแลกคะแนนจะไม่สามารถยกเลิกหรือขอคืนได้
              </p>
            </div>
          </div>
        </div>

        <div class="text-center-redeem" style="margin-top: 16px">
          <a
            class="confirm-bt light-color"
            type="submit"
            @click="confirmRedeem"
            v-if="enabledConfirm === true"
            >ยืนยัน</a
          >
          <a class="cancle-bt" type="submit" @click="cancel('redeemConfirm')">ยกเลิก</a>
        </div>
      </modal>

      <modal
        name="redeemGoods"
        width="80%"
        scrollable="true"
        height="auto"
        max-height="80%"
      >
        <div class="qrModal">
          <div class="card" style="width: 18rem">
            <div class="card-body">
              <h5 class="card-title">ยืนยันการแลกคะแนน</h5>
              <p class="card-text text-left">
                แลกคะแนน {{ reward.point | numFormat("0,000,000") }} เพื่อรับ
                {{ reward.name }} การและคะแนนจะไม่สามารถยกเลิกหรือขอคืนได้
              </p>
              <p class="red bold text-center">ระยะเวลาจัดส่ง 30 วัน</p>
              <p></p>
              <h5 class="card-title">ข้อมูลการจัดส่ง</h5>
              <div class="card-text">
                <div class="form-group">
                  <label for="exampleInputEmail1"
                    >ชื่อ-นามสกุล
                    <p>(* required)</p></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="shipping_name"
                    aria-describedby="shipping_name"
                    placeholder="ชื่อ"
                    v-model="shipping_name"
                  />
                </div>
                <div class="form-group">
                  <label for="shipping_phone"
                    >เบอร์โทรศัพท์
                    <p>(* required)</p></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="shipping_phone"
                    placeholder="08123456789"
                    v-model="shipping_phone"
                  />
                </div>
                <div class="form-group">
                  <label for="shipping_address"
                    >ที่อยู่
                    <p>(* required)</p></label
                  >
                  <textarea
                    class="form-control"
                    id="shipping_address"
                    rows="3"
                    v-model="shipping_address"
                  ></textarea>
                </div>
                <div class="form-group">
                  <label for="shipping_province"
                    >จังหวัด
                    <p>(* required)</p></label
                  >
                  <!--input
                type="text"
                class="form-control"
                id="shipping_phone"
                placeholder="08123456789"
                v-model="phone"
              /-->
                  <select
                    v-model="shipping_province"
                    id="shipping_province"
                    class="form-control"
                  >
                    <option disabled value="">เลือกจังหวัด</option>
                    <option
                      v-for="item in provincesList"
                      v-bind:value="item"
                      v-bind:key="item"
                    >
                      {{ item }}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label for="shipping_postcode"
                    >รหัสไปรษณีย์
                    <p>(* required)</p></label
                  >
                  <select
                    v-model="shipping_postcode"
                    id="shipping_postcode"
                    class="form-control"
                  >
                    <option disabled value="">รหัสไปรษณีย์</option>
                    <option
                      v-for="item in postCode"
                      v-bind:value="item"
                      v-bind:key="item"
                    >
                      {{ item }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="text-center-confirm" style="margin-top: 16px">
          <a
            class="confirm-bt-ship light-color"
            type="submit"
            @click="redeemGoods"
            v-if="enabledRedeem === true"
            >ยืนยัน</a
          >
          <a class="cancle-bt-ship" type="submit" @click="cancel('redeemGoods')"
            >ยกเลิก</a
          >
        </div>
      </modal>
      <modal name="qrCode" width="80%">
        <div class="text-center fixt" style="min-width: 100%">
          <p style="font-size: 25px; font-weight: 700; margin-bottom: 0rem">รหัสยืนยัน</p>
        </div>
        <div class="qrModal">
          <div class="qr">
            <qr-code :text="redeemCode" size="200"></qr-code>
          </div>
        </div>
        <div class="text-center" style="min-width: 100%; margin-top: 10px">
          <p>{{ redeemCode }}</p>
        </div>
        <div class="text-center">
          <div class="progress" style="height: 15px">
            <div
              class="progress-bar"
              role="progressbar"
              :style="'width:' + (countdown * 100) / count + '%'"
              :aria-valuenow="countdown"
              aria-valuemin="0"
              :aria-valuemax="count"
            >
              {{ expiring }} วินาที
            </div>
          </div>
        </div>
        <div class="text-center-confirm" style="margin-top: 0.5em">
          <a type="submit" class="cancle-bt-ship" @click="closeQr">ยกเลิก</a>
          <a type="submit" class="confirm-bt-ship light-color" @click="close">ปิด</a>
        </div>
      </modal>
    </body>
  </html>
</template>
<script>
import Navbar from "./navbar";
import VueQRCodeComponent from "vue-qrcode-component";
import { DateTimeFunc } from "../libs/constant.js";
// eslint-disable-next-line no-unused-vars
//let expiring = 15 * 60;
import Loading from "vue-loading-overlay";
export default {
  name: "",
  components: {
    loading: Loading,
    navbar: Navbar,
    "qr-code": VueQRCodeComponent,
  },
  computed: {
    startDate() {
      // alert(JSON.stringify(this.reward));
      let ymd = this.reward.effective_date.substring(0, 10).split("-");
      //alert(ymd);
      //alert(TH_DATE);
      let month = DateTimeFunc.TH_MONTH(ymd[1]);
      return ymd[2] + " " + month + " " + (parseInt(ymd[0]) + 543);
    },
    endDate() {
      let ymd = this.reward.expire_date.substring(0, 10).split("-");
      //return "";
      let month = DateTimeFunc.TH_MONTH(ymd[1]);
      return ymd[2] + " " + month + " " + (parseInt(ymd[0]) + 543);
    },
    countdown() {
      return this.expiring;
    },
    info() {
      return this.$store.state.profile;
    },
    provincesList() {
      let tmp = [];

      let result = this.$store.state.postcodeProvinceData
        .map((item) => {
          if (tmp.indexOf(item.provinceThai) == -1) {
            tmp.push(item.provinceThai);

            return item.provinceThai;
          }
        })
        .filter((items) => {
          return items !== undefined;
        });
      // console.log(result);
      return result.sort();
    },
    postCode() {
      let tmp = [];
      // let tmpPostCode ="";
      let result = this.$store.state.postcodeProvinceData
        .map((item) => {
          if (
            item.provinceThai == this.shipping_province &&
            tmp.indexOf(item.postcode) == -1
          ) {
            tmp.push(item.postcode);
            return item.postcode;
          } else {
            return item.something;
          }
        })
        .filter((item) => {
          return item !== undefined;
        });
      //console.log(result);
      return result.sort();
    },
  },
  data() {
    return {
      //info: this.$store.state.profile,
      // reward: this.$store.state.rewards[this.$route.query.rewardIndex || 0],
      enabledRedeem: true,
      enabledConfirm: true,
      reward: {},
      confirming: false,
      isLoading: false,
      rewardIndex: this.$route.query.rewardIndex || 0,
      expiring: 2 * 60,
      count: 2 * 60,
      countInterval: null,
      redeemCode: null,
      shipping_name:
        this.$store.state.profile.firstname + " " + this.$store.state.profile.lastname,
      shipping_phone: this.$store.state.profile.phone,
      shipping_address: "",
      infoPoint: this.$store.state.profile.point,
      success: false,
      failed: false,
      shipping_province: "",
      shipping_postcode: "",
      loaded: false,
    };
  },
  beforeDestroy() {
    clearInterval(this.countInterval);
  },
  beforeMount() {
    console.log("beforeMount");
    this.$store
      .dispatch("getRewardInfo", this.$route.params.rewardIndex)
      .then((result) => {
        console.log(result);
        this.reward = result;
        this.loaded = true;
      });
    //async ()=>{

    /*
      .then(response =>{
      console.log(response);
      this.reward = response;
      });
      */
    //}
  },
  methods: {
    async updateRewardQuantity(index) {
      if (this.infoPoint != this.$store.state.profile.point) {
        await this.$store.dispatch("decreaseRewardQuantity", index);
        this.isLoading = false;
        //alert("บันทึกข้อมูลเรียบร้อย");
        //this.goto("Redeem02");
      }
    },
    _setInterval() {
      //console.log(this.expiring);
      if (this.expiring <= 0) {
        //clearInterval(this.countInterval);
        //this.$modal.hide("qrCode");
        this.close();
        //alert("TIME OUT");
      } else {
        this.expiring -= 1;
      }
      //console.log(this.expiring);
      //document.getElementById("progressBar").value = 10 - timeleft;},
    },
    _countdown() {
      console.log("_countdown");
      //let _self = this;
      this.countInterval = setInterval(this._setInterval, 1000);

      //console.log(this.countInterval);
    },
    async confirmRedeem() {
      this.enabledConfirm = false;
      this.confirming = true;
      if (this.reward.rewardType == "Goods") {
        this.showModal("redeemGoods");
        this.$modal.hide("redeemConfirm");

        //
      } else if (this.reward.rewardType == "Lucky Draw") {
        //
        this.isLoading = true;
        try {
          this.$store
            .dispatch("createRedeem", {
              custId: localStorage.getItem("custId"),
              apiKey: localStorage.getItem("apiKey"),
              memberId: this.info._id,
              rewardId: this.reward._id,
              shipping_address: {
                name: this.shipping_name,
                phone: this.shipping_phone,
                address: this.shipping_address,
                state: this.shipping_province,
                postcode: this.shipping_postcode,
              },
            })
            .then((response) => {
              console.log("create Redeem");
              console.log(response);

              if (response.code == 0) {
                this.updateRewardQuantity(this.rewardIndex);
                this.success = true;
                this.$modal.hide("redeemGoods");
                this.$modal.hide("redeemConfirm");
                window.location.reload();
              } else {
                this.cancel("redeemGoods");
                this.failed = true;
              }
            });
        } catch (error) {
          this.failed = false;
        }
      } else {
        this.showModal("qrCode");
      }
      this.isLoading = false;
    },
    async showModal(modalName) {
      if (modalName == "qrCode") {
        this.expiring = this.count;

        this.$store
          .dispatch("createRedeem", {
            custId: localStorage.getItem("custId"),
            apiKey: localStorage.getItem("apiKey"),
            memberId: this.info._id,
            rewardId: this.reward._id,
            shipping_address: {
              name: this.shipping_name,
              phone: this.shipping_phone,
              address: this.shipping_address,
              state: this.shipping_province,
              postcode: this.shipping_postcode,
            },
          })
          .then((response) => {
            console.log(response);
            this.redeemCode = this.$store.state.redeem.temp.data.redeem_code;
            console.log(this.$store.state);
            this.$modal.hide("redeemGoods");
            this.$modal.hide("redeemConfirm");
            //window.location.reload();
          });

        this._countdown();
      }
      this.$modal.show(modalName);
    },
    async redeemGoods() {
      this.enabledRedeem = false;
      this.isLoading = true;
      this.confirming = true;
      let response = await this.$store.dispatch("createRedeem", {
        custId: localStorage.getItem("custId"),
        apiKey: localStorage.getItem("apiKey"),
        memberId: this.info._id,
        rewardId: this.reward._id,
        shipping_address: {
          name: this.shipping_name,
          phone: this.shipping_phone,
          address: this.shipping_address,
          state: this.shipping_province,
          postcode: this.shipping_postcode,
        },
      });
      console.log("create redeemGoods");
      console.log(response);
      await this.$store.dispatch("checkExistedMember", {
        line_id: localStorage.getItem("line_id"),
        custId: localStorage.getItem("custId"),
        apiKey: localStorage.getItem("apiKey"),
      });
      if (response.code == 0) {
        this.updateRewardQuantity(this.rewardIndex);
        this.$modal.hide("redeemGoods");
        this.$modal.hide("redeemConfirm");
        window.location.reload();
      } else {
        this.cancel("redeemGoods");
        this.$modal.hide("redeemConfirm");
        this.failed = true;
      }
      //console.log(response);
      //if (response.data.code == 0) {

      this.isLoading = false;
      //}
    },
    cancel(name) {
      this.$modal.hide(name);
    },
    async closeQr() {
      console.log(this.$store.state.redeem);
      await this.$store.dispatch("cancelRedeem", {
        custId: localStorage.getItem("custId"),
        apiKey: localStorage.getItem("apiKey"),
        memberId: this.info._id,
        rewardId: this.reward._id,
        memberRewardId: this.$store.state.redeem.temp.data._id,
      });
      // this.$modal.hide("qrCode");
      // clearInterval(this.countInterval);
      this.close();
    },
    async close() {
      this.$modal.hide("qrCode");
      clearInterval(this.countInterval);
      await this.$store.dispatch("checkExistedMember", {
        line_id: localStorage.getItem("line_id"),
        custId: localStorage.getItem("custId"),
        apiKey: localStorage.getItem("apiKey"),
      });
      this.updateRewardQuantity(this.rewardIndex);
    },
  },
  mounted() {
    clearInterval(this.countInterval);

    //this.$store.state.rewards[this.$route.params.rewardIndex];
  },
};
</script>
<style scoped>
@import "./Css/style.css";

p {
  font-size: 16px;
  color: #7f8285;
  text-align: left !important;
  margin-top: -13px !important;
  margin-left: 0px !important;
}
.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 0px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}
.title-page-l {
  width: 100%;
  top: 20px;
  position: absolute;
  overflow: visible;
  text-align: left;
  font-family: "Prompt";
  padding-left: 15px;
}
.title-page-l h1 {
  font-size: 30px;
  color: #ffffff;
  font-family: Prompt SemiBold;
  letter-spacing: 2px;
  font-family: "Prompt";
}
.title-page-l p {
  font-size: 14px;
  color: #ffffff;
  margin-bottom: -20px;
  text-align: left;
  margin-top: -10px;
}
.row-redeem {
  margin-left: 50px !important;
}
.bg-white-redeem {
  background: #fff;
  border-radius: 10px;

  width: 70%;
  position: relative;
  overflow: visible;
  top: 90px;
}

h1 {
  font-size: 20px;
  margin-top: 12px;
  margin-left: 12px;
}

.img-profile-redeem-page {
  display: block;
  height: 250px;
  float: none;
  margin-left: auto;
  margin-right: auto;
}
.name-product {
  font-family: "Prompt";
  font-weight: bold;
  color: #000000;
  margin-top: 16px;
  font-size: 19px;
}
.name-price {
  font-family: "Prompt";
  color: #7bc79a;
  padding: 0px 0px 0px 0px;
  margin-top: 3px;
  font-size: 24px;
}
.name-time {
  font-family: "Prompt";
  color: #7f8285;
  margin-bottom: 0px;
  font-size: 13px;
  margin-left: 0px;
}
.condition {
  font-family: "Prompt";
  color: #7f8285;
  margin-bottom: 0px;
  font-size: 14px;
  margin-left: 13px;
}
.name-loca {
  font-family: "Prompt";
  color: #7f8285;
  margin-top: 50px;
  margin-bottom: 0px;
  font-size: 16px;
  margin-left: 13px;
}
.iconpoint {
  display: block;
  margin-right: 3px;
  margin-top: 3px;
  width: 30px;
  height: 30px;
  float: left;
  padding: 3px 3px 3px 3px;
}
.iconpoint-top {
  display: block;
  margin-left: 3px;
  margin-right: 16px;
  margin-top: -6px;
  width: 40px;
  height: 40px;
  float: left;
}
.progress {
  margin-top: 5px;
  margin-right: 2px;
  height: 0.9rem;
  border-radius: 0px;
  width: 300px;
}
.p-redeem {
  font-size: 16px;
  color: #7f8285 !important;
  text-align: left !important;
}
.progress-bar {
  background-color: #7bc79a;
  border-radius: 2px;
  width: 300px;
}
.detail {
  margin-top: 100px;
  padding: 5px 15px 15px 15px;
}
.ifor {
  float: right;
  width: 30px;
  height: 30px;
  margin-top: -3px;
}
.btn-block {
  display: block;
  width: 100%;

  margin-left: auto;
  margin-right: auto;
}
h5.card-title {
  text-align: center;
}
.card-body {
  flex: 1 1 auto;
  padding: 0rem 1rem;
}
.mt-30 {
  margin-top: 20px;
  margin-bottom: 20px;
}
.bt {
  margin-left: 10px;
  margin-right: 10px;
}

.footer {
  margin-bottom: 200px;
  padding-left: 20px;
  padding-right: 20px;
}

.qrModal {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.qr > img {
  text-align: center;
  display: inline-block;
  padding-left: auto;
  padding-right: auto;
}
.text-center {
  display: flex;
  justify-content: center;
  padding-left: auto;
  padding-right: auto;
  width: 100%;
}
.text-center-confirm {
  display: inline-grid;
  justify-content: center;
  padding-left: auto;
  padding-right: auto;
  width: 100%;
}
a[type="submit"] {
  margin-left: 0px;
}

.vm--modal {
  top: 10% !important;
  max-height: 90% !important;
  overflow: auto !important;
  height: auto !important;
}
.text-left {
  text-align: center;
}
.bold {
  font-weight: bold;
}
.red {
  color: brown;
}
.confirm-bt {
  margin-top: 16px;
  display: inline-grid;
  /*background-color: #b50610;*/
  margin-top: 16px;
  display: inline-grid;
  color: #fff;
  width: 90%;
  margin-left: 15px !important;
  text-align: center;
  border-radius: 5px;
}
.cancle-bt {
  margin-top: 16px;
  display: inline-grid;
  background-color: #626363;
  margin-top: 16px;
  display: inline-grid;
  color: #fff;
  width: 90%;
  margin-left: 15px !important;
  text-align: center;
  border-radius: 5px;
}
.confirm-bt-ship {
  margin-top: 16px;
  display: inline-grid;
  /*background-color: #b50610;*/
  margin-top: 16px;
  display: inline-grid;
  color: #fff;
  width: 90%;
  margin-left: 15px !important;
  text-align: center;
  border-radius: 5px;
  padding-left: 110px;
  padding-right: 110px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.cancle-bt-ship {
  padding-left: 110px;
  padding-right: 110px;
  display: inline-grid;
  background-color: #626363;
  margin-top: 16px;
  display: inline-grid;
  color: #fff;
  width: 90%;
  margin-left: 15px !important;
  text-align: center;
  border-radius: 5px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.btn {
  transition: none !important;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
a.confirm-bt {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
a.cancle-bt {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.disabled {
  pointer-events: none;
  cursor: default;
  opacity: 0.6;
}
</style>
